<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.containers'), name: 'company_containers' },
            { text: container.name, name: 'company_container', params: { container_uuid: container.uuid } },
            { text: $t('containers.addEmptyingTemplate') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <EmptyingTemplateNewForm :afterSubmit="onSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import EmptyingTemplateNewForm from '@/components/EmptyingTemplates/NewForm.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import containersApi from '@/api/container'
import emptyTemplatesApi from '@/api/emptyTemplates'

export default {
  name: 'company_container_type',
  data() {
    return {
      container: {},
    }
  },
  components: {
    BreadCrumbs,
    CompanyNav,
    EmptyingTemplateNewForm,
    SectionHeader,
  },
  methods: {
    async getData() {
      this.container = await containersApi.get(this.$route.params.container_uuid)
    },
    async onSubmit(newTemplateData) {
      const result = await emptyTemplatesApi.create(this.$route.params.container_uuid, newTemplateData)
      if (result.success) {
        await this.$router.push(`/company/containers/${this.$route.params.container_uuid}`)
      }
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>
